// Date / time formatting helpers, all timezone-aware.
// Trip timezone (America/Juneau) is the default for trip-context displays;
// flight times retain their own offset (PDX flights show in PT, JNU in AKT).

export function formatDateTime(iso, opts = {}) {
  const { timezone, withZone = true, dateStyle = 'medium', timeStyle = 'short' } = opts;
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    dateStyle,
    timeStyle,
    timeZone: timezone || undefined,
    timeZoneName: withZone ? 'short' : undefined,
  }).format(d);
}

export function formatTime(iso, opts = {}) {
  const { timezone, withZone = true } = opts;
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timezone || undefined,
    timeZoneName: withZone ? 'short' : undefined,
  }).format(d);
}

export function formatDateShort(iso, opts = {}) {
  const { timezone } = opts;
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: timezone || undefined,
  }).format(d);
}

export function diffParts(future, now = Date.now()) {
  const target = typeof future === 'string' ? new Date(future).getTime() : future;
  const ms = Math.max(0, target - now);
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds, totalMs: ms, isPast: ms === 0 };
}
